// extracted by mini-css-extract-plugin
export default {"dotBarChart":"DotBarChart_dotBarChart__0Bw8i"};